import React, { useContext, useState } from "react";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import {
	BrWidgetOtherConfig,
	ExeFeedWidgetOtherConfig,
	LsOtherConfig,
} from "@features/live-widgets/shared";
import {
	EventContext,
	OfferStoreContext,
	SportOfferContext,
} from "@gp/components";
import { ProviderNameEnum } from "@gp/models";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import classNames from "classnames";
import { observer } from "mobx-react";

export default observer(function WidgetToggleButton(props: {
	isOnEventView?: boolean;
	/** Will widget button control side widget */
	isForSideWidget?: boolean;
}) {
	const location: WidgetLocation = props.isForSideWidget
		? WidgetLocation.SIDE
		: WidgetLocation.EVENT_OFFER;

	const widgetStore = useLiveWidgetStore();
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);
	const store = useContext(OfferStoreContext);

	const teamOneName =
		store.lookupsStore.teams.get(event.teamOneId || "")?.name || "";
	const teamTwoName =
		store.lookupsStore.teams.get(event.teamTwoId || "")?.name || "";

	const isActive = widgetStore.findActiveLmtWidget(event.id, location);

	const [isHover, setIsHover] = useState(false);

	//#region css classes

	// class order matters here

	const isDisabled = (function () {
		if (event.isOutright || !event.source?.matchId) {
			return true;
		}
		if (event.source.providerName == ProviderNameEnum.LSports) {
			return (
				!WEBPACK_IS_LS_WIDGET_ENABLED ||
				!LsOtherConfig.supportedSports.includes(sport?.abrv)
			);
		}
		if (event.source.providerName == ProviderNameEnum.BetRadar) {
			return !BrWidgetOtherConfig.supportSports.includes(sport?.abrv);
		}
		if (event.source.providerName == ProviderNameEnum.ExeFeed) {
			return !ExeFeedWidgetOtherConfig.supportSports.includes(
				sport?.abrv
			);
		}

		return true;
	})();

	const buttonClasses = classNames(
		"at-actionStatsWidget offer__actions__btn btn",
		{
			"is-disabled": isDisabled,
			"btn--square btn--square--sml btn--ghost": props.isOnEventView,
			"btn--square--reset": !props.isOnEventView,
		}
	);

	const iconClasses = classNames(
		"offer__actions__icon",
		"u-icon",
		"u-icon--sml",
		{
			[`u-icon--field--active u-icon--field--${sport?.abrv}--active`]:
				!isHover && !isActive && !isDisabled,
			[`u-icon--field--selected u-icon--field--${sport?.abrv}--selected`]:
				(isHover || isActive) && !isDisabled,
			[`u-icon--field--disabled u-icon--field--${sport?.abrv}--disabled`]:
				isDisabled,
		}
	);

	if (props.isOnEventView && isDisabled) {
		return null;
	}

	return (
		<button
			disabled={isDisabled}
			className={buttonClasses}
			type="button"
			onClick={() => {
				if (!event.source?.matchId) {
					return;
				}
				widgetStore.toggleLmtWidget({
					sport: sport.abrv,
					provider: event.source!.providerName,
					matchId: event.source.matchId,
					eventId: event.id,
					teamOneName: teamOneName,
					teamTwoName: teamTwoName,
					location: location,
				});
			}}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
		>
			<i className={iconClasses} />
		</button>
	);
});
